/**
 * The events that signal a genuine, engaged visitor.
 *
 * ONE list, shared by everything that gates on "first interaction":
 * `useFirstInteraction()` (AdSense, the consent banner, the analytics
 * autopilot) and the inline GTM loader in components/analytics/GtmScript.tsx,
 * which cannot import a hook but interpolates this array into its script.
 * Two copies had already appeared once; a mismatch means the ad stack and the
 * analytics container disagree about what an interaction is, and the mobile
 * Lighthouse gate stops describing what the hook promises.
 *
 * Deliberately excludes `scroll`: Lighthouse (and other headless auditors)
 * scroll the page programmatically while gathering, which fires `scroll` —
 * gating on it would let synthetic loads trip the third-party stack. Real
 * scrolling still triggers via `wheel` (mouse/trackpad), `touchstart` (mobile)
 * or `keydown` (space/arrows), so coverage of real users is unaffected.
 *
 * A plain module with no "use client" directive, so a Server Component can
 * import the constant as a value rather than as a client reference.
 */
export const INTERACTION_EVENTS = ["pointerdown", "keydown", "touchstart", "wheel"] as const;
